import routerOptions0 from "/opt/build/repo/node_modules/.pnpm/nuxt@4.5.2_ddfa93a9b184680e8cef752accbdf0d4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  strict: true,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}